import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { DashboardLayout } from "component/layout/dashboard";
import { OneCrmIframe } from "component/shared/iframe/onecrm";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import { FeatherIcon } from "component/shared/feather-icon";

interface Props extends PageProps, Router.RouteComponentProps {
}

class Component extends React.Component<Props> {

	public render() {
		const title = "Team List";
		return (
			<DashboardLayout
				title={title}
				header={
					<Mui.Typography variant="h1">
						<FeatherIcon>
							<Icons.Sliders />
						</FeatherIcon>
						{title}
					</Mui.Typography>
				}
				iframe={<OneCrmIframe url="/admin/Team/TeamManagement.aspx" />}
			/>
		);
	}

}

export const OneTeamListPage = Component;